"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "usePasswordControl", {
  enumerable: true,
  get: function get() {
    return _hooks.usePasswordControl;
  }
});
exports["default"] = void 0;

var _system = _interopRequireWildcard(require("../../../utils/system"));

var _FormGroup = _interopRequireDefault(require("../FormGroup/FormGroup"));

var _FormLabel = _interopRequireDefault(require("../FormLabel/FormLabel"));

var _FormControl = _interopRequireDefault(require("../FormControl/FormControl"));

var _FormCheck = _interopRequireDefault(require("../FormCheck/FormCheck"));

var _FormRadio = _interopRequireDefault(require("../FormRadio/FormRadio"));

var _FormFeedback = _interopRequireDefault(require("../FormFeedback/FormFeedback"));

var _FormField = _interopRequireDefault(require("../FormField/FormField"));

var _FormSelect = _interopRequireDefault(require("../FormSelect/FormSelect"));

var _FormControlGroup = _interopRequireDefault(require("../FormControlGroup/FormControlGroup"));

var _FormAddonAddornament = _interopRequireDefault(require("../FormAddonAddornament/FormAddonAddornament"));

var _FormAddonElementLeft = _interopRequireDefault(require("../FormAddonElementLeft/FormAddonElementLeft"));

var _FormAddonElementRight = _interopRequireDefault(require("../FormAddonElementRight/FormAddonElementRight"));

var _FormCheckGroup = _interopRequireDefault(require("../FormCheckGroup/FormCheckGroup"));

var _FormPasswordInput = _interopRequireDefault(require("../FormPasswordInput/FormPasswordInput"));

var _hooks = require("../hooks");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Form = (0, _system["default"])('form')({
  label: 'Form'
}, {
  boxSizing: 'border-box',
  display: 'block',
  margin: 0
}, (0, _system.classesStyles)('root'));
Form.displayName = 'Form';
Form.Group = _FormGroup["default"];
Form.Label = _FormLabel["default"];
Form.Control = _FormControl["default"];
Form.Check = _FormCheck["default"];
Form.Radio = _FormRadio["default"];
Form.Feedback = _FormFeedback["default"];
Form.Field = _FormField["default"];
Form.Select = _FormSelect["default"];
Form.ControlGroup = _FormControlGroup["default"];
Form.AddonElementLeft = _FormAddonElementLeft["default"];
Form.AddonElementRight = _FormAddonElementRight["default"];
Form.AddonAddornament = _FormAddonAddornament["default"];
Form.CheckGroup = _FormCheckGroup["default"];
Form.PasswordInput = _FormPasswordInput["default"];
var _default = Form;
exports["default"] = _default;

//# sourceMappingURL=Form.js.map